import telliIcon from "@/assets/icons/telli.webp";
import smuIcon from "@/assets/icons/smu.webp";
import umIcon from "@/assets/icons/um.webp";
import awareIcon from "@/assets/icons/aware.webp";
import buergerstiftungIcon from "@/assets/icons/buergerstiftung.webp";
import nurseryIcon from "@/assets/icons/nursery.webp";
import enpalIcon from "@/assets/icons/enpal.webp";
import skipIcon from "@/assets/icons/skip.webp";
import vodafoneIcon from "@/assets/icons/vodafone.webp";
import stclaresIcon from "@/assets/icons/stclares.webp";
import comeniusIcon from "@/assets/icons/comenius.webp";
import figmaIcon from "@/assets/icons/figma.webp";
import framerIcon from "@/assets/icons/framer.webp";
import lovableIcon from "@/assets/icons/lovable.webp";
import notionIcon from "@/assets/icons/notion.webp";
import awareHealthAppIcon from "@/assets/icons/aware-health-app.webp";
import yukaIcon from "@/assets/icons/yuka.webp";
import pushfitIcon from "@/assets/icons/pushfit.webp";
import notebooklmIcon from "@/assets/icons/notebooklm.webp";
import chatgptIcon from "@/assets/icons/chatgpt.webp";
import claudeIcon from "@/assets/icons/claude.webp";
import perplexityIcon from "@/assets/icons/perplexity.webp";
import substackIcon from "@/assets/icons/substack.webp";
import wetransferIcon from "@/assets/icons/wetransfer.webp";
import dazzcamIcon from "@/assets/icons/dazzcam.webp";
import surflineIcon from "@/assets/icons/surfline.webp";
import spielwerkIcon from "@/assets/icons/spielwerk.webp";
import elevenlabsIcon from "@/assets/icons/elevenlabs.webp";
import alltrailsIcon from "@/assets/icons/alltrails.webp";
import flightyIcon from "@/assets/icons/flighty.webp";

export interface ListItemData {
  icon?: string;
  emoji?: string;
  title: string;
  subtitle: string;
  link?: string;
  noBorder?: boolean;
  roles?: { title: string; subtitle: string; duration?: string }[];
  sectionLabel?: string;
  hideAction?: boolean;
}

export const workExperience: ListItemData[] = [
  {
    icon: telliIcon,
    title: "Telli",
    subtitle: "Growth & Founders Associate",
    hideAction: true,
  },
  {
    icon: awareIcon,
    title: "Aware Health GmbH",
    subtitle: "",
    roles: [
      { title: "Working Student", subtitle: "Design & Product" },
      { title: "Intern", subtitle: "Product, Growth & Marketing" },
    ],
  },
  { icon: enpalIcon, title: "Enpal B.V", subtitle: "SEO & Business Development Intern" },
  { icon: skipIcon, title: "Skip App GmbH", subtitle: "Web Development & Branding Intern", noBorder: true },
  { icon: vodafoneIcon, title: "Vodafone GmbH", subtitle: "Marketing & Media Intern", noBorder: true },
];

export const volunteering: ListItemData[] = [
  { icon: buergerstiftungIcon, title: "Bürgerstiftung Düsseldorf", subtitle: "Sales Representative" },
  { icon: nurseryIcon, title: "Nursery School", subtitle: "Assistant", noBorder: true },
];

export const education: ListItemData[] = [
  { icon: umIcon, title: "Maastricht University", subtitle: "B.Sc. International Business" },
  { icon: smuIcon, title: "Singapore Management University", subtitle: "Exchange Semester" },
  { icon: stclaresIcon, title: "St. Clare's International College", subtitle: "Advanced English" },
  { icon: comeniusIcon, title: "Comenius Gymnasium", subtitle: "Abitur" },
];

export const inspirationThemes = [
  { emoji: "📱", label: "Apps", slug: "apps", subtitle: "Tools I love", count: 19 },
  { emoji: "👤", label: "People", slug: "people", subtitle: "Who inspires me", count: 3 },
  { emoji: "📖", label: "Books", slug: "books", subtitle: "Must reads", count: 2 },
];

export const inspirationData: Record<string, { title: string; items: ListItemData[] }> = {
  apps: {
    title: "Apps",
    items: [
      { icon: figmaIcon, title: "Figma", subtitle: "Design", link: "https://www.figma.com/", sectionLabel: "Building", noBorder: true },
      { icon: framerIcon, title: "Framer", subtitle: "Website Builder", link: "https://www.framer.com/", noBorder: true },
      { icon: lovableIcon, title: "Lovable", subtitle: "AI Engineer", link: "https://www.lovable.dev/", noBorder: true },
      { icon: notionIcon, title: "Notion", subtitle: "Notes & Docs", link: "https://www.notion.com/" },
      { icon: awareHealthAppIcon, title: "Aware Health", subtitle: "Smart & Preventive Blood Testing", link: "https://www.aware.app/en", sectionLabel: "Health", noBorder: true },
      { icon: yukaIcon, title: "Yuka", subtitle: "Product & Food Scanner", link: "https://www.yuka.io/" },
      { icon: pushfitIcon, title: "PushFit Pro", subtitle: "Push Up Tracker", link: "https://www.pushfit.app/", noBorder: true },
      { icon: chatgptIcon, title: "ChatGPT", subtitle: "Holistic Creative AI", link: "https://www.openai.com/chatgpt/", sectionLabel: "AI", noBorder: true },
      { icon: claudeIcon, title: "Claude", subtitle: "Coding & Problem-Solving AI", link: "https://www.anthropic.com/claude", noBorder: true },
      { icon: perplexityIcon, title: "Perplexity", subtitle: "Real-Time Research AI", link: "https://www.perplexity.ai/", noBorder: true },
      { icon: notebooklmIcon, title: "NotebookLM", subtitle: "Research & Synthesis AI", link: "https://notebooklm.google/", noBorder: true },
      { icon: substackIcon, title: "Substack", subtitle: "Newsletter Platform", link: "https://substack.com/about", sectionLabel: "Others", noBorder: true },
      { icon: wetransferIcon, title: "WeTransfer", subtitle: "File Sharing", link: "https://wetransfer.com/", noBorder: true },
      { icon: dazzcamIcon, title: "Dazz Cam", subtitle: "Retro Camera", link: "https://dazzcam.org/", noBorder: true },
      { icon: surflineIcon, title: "Surfline", subtitle: "Surf Forecast", link: "https://www.surfline.com/", noBorder: true },
      { icon: spielwerkIcon, title: "Spielwerk", subtitle: "Gaming", link: "https://spielwerk.app/", noBorder: true },
      { icon: elevenlabsIcon, title: "ElevenLabs", subtitle: "AI Voice", link: "https://www.elevenlabs.io/", noBorder: true },
      { icon: alltrailsIcon, title: "AllTrails", subtitle: "Hiking & Trails", link: "https://www.alltrails.com/", noBorder: true },
      { icon: flightyIcon, title: "Flighty", subtitle: "Flight Tracker", link: "https://www.flighty.com/", noBorder: true },
    ],
  },
  people: {
    title: "People",
    items: [
      { emoji: "👤", title: "Person Name", subtitle: "Why they inspire you" },
      { emoji: "👤", title: "Another Person", subtitle: "What you learned from them" },
      { emoji: "👤", title: "Third Person", subtitle: "Their impact on you" },
    ],
  },
  books: {
    title: "Books",
    items: [
      { emoji: "📖", title: "Book Title", subtitle: "Author" },
      { emoji: "📖", title: "Another Book", subtitle: "Author" },
    ],
  },
  podcasts: {
    title: "Podcasts",
    items: [
      { emoji: "🎙️", title: "Podcast Name", subtitle: "Host" },
      { emoji: "🎙️", title: "Another Podcast", subtitle: "Host" },
    ],
  },
  companies: {
    title: "Companies",
    items: [
      { emoji: "🏢", title: "Company Name", subtitle: "What you admire" },
      { emoji: "🏢", title: "Another Company", subtitle: "Their innovation" },
    ],
  },
};

export const categoryData: Record<string, { title: string; items: ListItemData[] }> = {
  experience: {
    title: "Experience",
    items: workExperience,
  },
  volunteering: {
    title: "Volunteering",
    items: volunteering,
  },
  education: {
    title: "Education",
    items: education,
  },
};
